import * as Sentry from '@sentry/react'

if (process.env.REACT_APP_SENTRY_DSN && process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV
  })
}

export default Sentry



// WEBPACK FOOTER //
// ./src/utils/sentry.js